import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes.ts";
import type { ChartReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import type { DrillDownArgs } from "../DrillDownArgs.ts";
import SmartViewChartContainer from "./SmartViewChartContainer";

interface Props {
  widget: SmartViewWidget;
  data: ChartReportConfigurationForRunning;
  onDrillDown: (args: DrillDownArgs) => void;
}

const SmartViewChartWidget = ({ data, widget, onDrillDown }: Props) => {
  return <SmartViewChartContainer data={data} widget={widget} onDrillDown={onDrillDown} />;
};

export default SmartViewChartWidget;
